import { Text, Stack, Link } from "@certn/cascadia";
import {
  Container,
  Layout,
  MediaQuery,
  Tab,
  TabList,
  TabPanel,
  Tabs,
} from "@certn/cascadia-react";
import { Skeleton } from "@certn/cascadia-react/patterns/skeleton/Skeleton";
import { Trans, useTranslation } from "react-i18next";
import { Route, Routes, useLocation, useResolvedPath } from "react-router-dom";
import { createEndsWithTabIdMapper } from "@certn/utils";

import { TasksTab } from "./tabs/TasksTab";
import { AppFooterLinks } from "../../components/app-footer/AppFooterLinks";
import { AppHeader } from "../../components/app-header/AppHeader";
import { AppNavigation } from "../../components/app-navigation/AppNavigation";
import { PageTitle } from "../../components/page-title/PageTitle";
import { useTasks } from "../../hooks/useTasks";

export function Tasks() {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const url = useResolvedPath("").pathname;
  const {
    data,
    isLoading,
    params,
    handlePageChange,
    handlePageSizeChange,
    handleTaskMutation,
  } = useTasks();

  const mapSelectedTabId = createEndsWithTabIdMapper(
    [{ suffix: "/done", id: "done-tab" }],
    "active-tab"
  );

  return (
    <Layout
      layout="full-width"
      header={<AppHeader />}
      navigation={<AppNavigation />}
      footer={<AppFooterLinks />}
    >
      <Container layout="full-width">
        <PageTitle>
          {isLoading ? <Skeleton width="100" /> : t("Tasks")}
        </PageTitle>
        <MediaQuery sm type="hide">
          <Stack orientation="horizontal" gap="space-2">
            <Text color="text-weak" isLoading={isLoading}>
              <Trans>
                Tasks are notifications about cases you and your team have
                ordered and actions you need to take regarding those cases.
              </Trans>
            </Text>
            <Link
              target="_blank"
              href="https://portal.certn.co/hc/en-us/articles/27892023518227-Tasks"
              textStyle="global/body-secondary"
              linkStyle="monochrome"
              testID="tasks-learn-more-link"
            >
              {isLoading ? <Skeleton width="100" /> : <Trans>Learn more</Trans>}
            </Link>
          </Stack>
        </MediaQuery>
        <Tabs
          selectedKey={mapSelectedTabId(pathname)}
          gap="space-4"
          testID="tab-holder"
        >
          <TabList aria-label={t("Task statuses")}>
            <Tab id="active-tab" href={url} testID="tasks-active-tab">
              {isLoading ? <Skeleton width="100px" /> : t("Active")}
            </Tab>
            <Tab id="done-tab" href={`${url}/done`} testID="tasks-done-tab">
              {isLoading ? <Skeleton width="100px" /> : t("Done")}
            </Tab>
          </TabList>
          <TabPanel id={mapSelectedTabId(pathname)}>
            <Routes>
              <Route
                path=""
                element={
                  <TasksTab
                    tab="ACTIVE"
                    isLoading={isLoading}
                    data={data}
                    params={params}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                    handleTaskMutation={handleTaskMutation}
                  />
                }
              />
              <Route
                path="/done"
                element={
                  <TasksTab
                    tab="COMPLETE"
                    isLoading={isLoading}
                    data={data}
                    params={params}
                    handlePageChange={handlePageChange}
                    handlePageSizeChange={handlePageSizeChange}
                    handleTaskMutation={handleTaskMutation}
                  />
                }
              />
            </Routes>
          </TabPanel>
        </Tabs>
      </Container>
    </Layout>
  );
}
